// Port of api/fuel/app/classes/insights/hindex/plays.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'plays',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: ['suitability.duration', 'suitability.count'],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_plays || !owner.get_count_plays()) return {}

        var data = []
        for (var d = 0; d < 100; d++) {
            data.push(0)
        }

        var currentHindex = this._data.current.get_hindex()
        var min = Math.floor((currentHindex * currentHindex) / 100)
        var max = min + 1000

        var raw = Util.query(
            'SELECT t.user_id AS u, CAST(t.track_plays / 10 AS INTEGER) AS x, COUNT(t.user_id) AS c' +
            ' FROM hindex_track t' +
            ' WHERE t.hindex_id = ' + this._data.track.get_hindex_id() +
            ' AND t.track_plays > ' + min +
            ' AND t.track_plays < ' + max +
            ' AND t.track_hindex = ' + currentHindex +
            ' GROUP BY x'
        )

        for (var i = 0; i < raw.length; i++) {
            var idx = parseInt(raw[i].x, 10)
            data[(idx === 100) ? 99 : idx] += parseInt(raw[i].c, 10)
        }

        return {
            plays: {
                values: data,
                min: min,
                self: Math.floor(owner.get_count_plays() / 10)
            }
        }

    }
})
